<template>
    <div class="container-fluid">

        <CRow class="pr-2">
    <CCol col="12" xl="10" class="p-0">
      <CCard class="pt-2">
        <CCardBody>
          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Nastavenia</h6>
                            Používatelia</span>
                          <span slot="extra">
                            <div class="text-right system-options w-100 d-block" style="">
                     <router-link to="/user/add" class="d-none d-md-inline"><a-button type="primary" >Nový používateľ</a-button></router-link>
                     <span class="d-none d-md-inline">
                     <router-link to="/roles"><a-button type="secondary" class="mr-2" >Role používateľov</a-button></router-link>
                     <router-link to="/permissions"><a-button type="secondary" class="mr-2" >Právomoci</a-button></router-link>
                     <router-link to="/users-settings"><a-button type="secondary" class="mr-2">Nastavenia</a-button></router-link>
                     </span>
                     <a-dropdown class="d-md-none">
                       <a-button><i class="fas fa-ellipsis-v"></i></a-button>
                       <a-menu slot="overlay">
                         <a-menu-item><router-link to="/user/add">Nový používateľ</router-link></a-menu-item>
                         <a-menu-item><router-link to="/roles">Role používateľov</router-link></a-menu-item>
                         <a-menu-item><router-link to="/permissions">Právomoci</router-link></a-menu-item>
                         <a-menu-item><router-link to="/users-settings">Nastavenia</router-link></a-menu-item>
                       </a-menu>
                     </a-dropdown>

            </div>
</span>


                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :rowKey="record => record.id"
                                    :pagination="pagination"
                                    :dataSource="data"
                                    :loading="loading"
                                     @change="handleTableChange"
                                    :scroll="{ x: 700 }"
                                    class="table-flush">
                                <template slot="user_role" slot-scope="user">
 <span class="text-left text-lowercase" :key="index" v-for="(role,index) in JSON.parse(user.type_id)"> {{roleops[role]}}<span v-if="index+1 < JSON.parse(user.type_id).length">, </span></span>
                                </template>
                                <template slot="name" slot-scope="user">
                                    <router-link :to="'/user/' + user.id"><a-button class="mr-2">Upraviť</a-button></router-link>
                                    <a-popconfirm placement="topRight"
                                                  @confirm="confirm(user.id)"
                                                  @cancel="cancel"
                                                  okText="Áno"
                                                  cancelText="Nie">
                                        <template slot="title">
                                            <h5 color="danger" >Prajete si tohoto používateľa?</h5>
                                            Používateľ bude trvalo odstránená z vašej stránky.
                                        </template>
                                        <a-button type="secondary"  icon="fas fa-trash"    textColor="default" title="Zmazať">Zmazať</a-button>
                                    </a-popconfirm>
                                </template>

                            </a-table>
                        </div>
                        </a-card>
                        </CCardBody>
                        </CCard>
                        </CCol>
<CCol col="12" xl="2" class="pl-0 d-none d-xl-block">
    <CCard class="p-0 pt-2 filter-side">
        <CCardBody>

          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
            <span slot="extra">  <a-button @click="applyFilter">Filtrovať</a-button></span>
                          <span slot="title">Filter</span>
                          <div class="pr-4">

          <a-button class="mb-3 mt-3 float-right" @click="applyFilter">Filtrovať</a-button>
          </div>
          </a-card>
</CCardBody>
</CCard>
        </CCol>
        </CRow>

    </div>
</template>
<script>

    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"

    const columns = [
       {
            title: '',
            width: '10px',
        },  {
            title: 'Meno',
            dataIndex: 'name',
            sorter: true,
            width: '20%',
        },
        {
            title: 'Typ konta',
            scopedSlots: {customRender: 'user_role'},
            sorter: true,
            key: 'type_id',
            width: '20%',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        },
         {
            title: '',
            width: '10px',
        },
    ];

    export default {
        name: "users",
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                roleops: [],
                loading: false,
                colorsto: JSON.parse(localStorage.colors),
                  pagination: {
                    hideOnSinglePage: false,
                    total: 0,
                    pageSize: 50, // default number of pages per page
                    showSizeChanger: true, // display can change the number of pages per page
                    pageSizeOptions: ['10', '20', '30','50','100','300','1000'], // number of pages per option
                    showTotal: total => `Položiek: ${total}`, // show total
                    showSizeChange: (current, pageSize) => {  this.pageSize = pageSize; }, // update display when changing the number of pages per page
                },
                columns,
            };
        },

        mounted() {
            dataService.axiosFetch("roles").then(results => {

                results.forEach(obj => {
                    var iid = obj.id;
                    var vval = obj.title;
                    this.roleops[iid] = vval;


                });

                   this.$nextTick(() => {
                this.fetch();

            })

            });


        },
        methods: {
             handleTableChange(pagination, filters, sorter) {
                console.log(sorter);
        const sortField = sorter.columnKey || null; // Extract the sort field
        const sortOrder = sorter.order || null; // Extract the sort order
        this.fetch({ ...pagination }, { ...filters }, { field: sortField, order: sortOrder });
    },
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {

                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
             fetch(pagination = {}, filters = {}, sorter = {}) {
        this.loading = true;
        const { field: sortField, order: sortOrder } = sorter;

        // Update the data fetch logic to use sorting
        dataService.axiosPost(this.$options.name, {
            params: {
                page: pagination.current || 1,
                size: pagination.pageSize || 50,
                sortField,
                sortOrder, // 'ascend' or 'descend'
                ...filters
            }
        }).then(results => {
            this.pagination.total = parseInt(results.data.data.pop());
            this.data = results.data.data; // Assuming `results.data` is the paginated data

            this.loading = false;
        });
    },
            applyFilter() {
              this.fetch();
            }

        },
    };
</script>

<style scoped>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

@media (max-width: 767px) {
  .edit-card .ant-card-head-wrapper {
    flex-direction: row !important;
    align-items: center !important;
  }
  .edit-card .ant-card-head-title {
    min-height: auto !important;
    padding: 8px 0 !important;
    flex: 1;
    overflow: visible;
  }
  .edit-card .ant-card-extra {
    padding: 8px 0 !important;
  }
}

</style>
